import { render, staticRenderFns } from "./CidInit.vue?vue&type=template&id=35801a2e"
import script from "./CidInit.vue?vue&type=script&lang=js"
export * from "./CidInit.vue?vue&type=script&lang=js"
import style0 from "./CidInit.vue?vue&type=style&index=0&id=35801a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports